export enum AssistanceSearchType {
    DIAGNOSTIC = "FDIAG",
    ASSISTANCE = "FASSIST"
}
